import { render, staticRenderFns } from "./BankDetailsData.vue?vue&type=template&id=7a22a428&"
import script from "./BankDetailsData.vue?vue&type=script&lang=js&"
export * from "./BankDetailsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports